<template>
  <div>
    <div v-if="data.isLoading" class="ajax-loading-wrapper">
      <span class="ajax-loading"></span>
    </div>
    <div v-if="!data.isLoading">
      <GMapMap
        :zoom="zoom"
        :center="data.mapCentre"
        :options="data.options"
        style="width:100%;  height: 500px;"
      >
          <div
            :key="index"
            v-for="(marker, index) in data.markers"
          >
            <GMapMarker
              :position="{lat: marker.lat, lng: marker.lng}"
              @click="openWindow(marker.id)"
              :icon=marker.icon
            ></GMapMarker>
            <GMapInfoWindow
              @closeclick="data.window_open_id=false"
              :opened="data.window_open_id === marker.id"
              :position="{lat: marker.lat, lng: marker.lng}"
            >
              <div class='map__marker'>
                <div class='map__marker-info'>
                  <div class='map__marker-text'>
                    <div class='map__marker-name map__marker-name--village'>{{ marker.name }}</div>
                    <div class='map__marker-address map__marker-address--village'>{{ marker.address }}</div>
                  </div>
                </div>
              </div>
            </GMapInfoWindow>
          </div>
      </GMapMap>
    </div>
  </div>
</template>

<script setup>
import { defineProps, reactive, onMounted } from 'vue';
import axios from 'axios';

const props = defineProps({
  mapCentre: {
    type: Object,
    default: () => [],
  },
  zoom: {
    type: Number,
    default: 8,
  },
  type: {
    type: String,
    default: 'village',
  },
  defOpenId: {
    type: Number,
    default: 0,
  },
  villageId: {
    type: Number,
    default: 0,
  },
});

// Data properties
const data = reactive({
  options: {
    mapTypeControl: false,
    streetViewControl: false,
    zoomControlOptions: {
      position: 3 // top right
    },
  },
  mapCentre: [],
  locationMarkers: [],
  window_open_id: props.defOpenId,
  markers: [],
  isLoading: true,
});

const openWindow = (id) => {
  data.window_open_id = id;
};

onMounted(() => {
  let url = `/ajax/village-map/${props.villageId}`;

  if (props.type === 'careHome') {
    url = `/ajax/care-home-map/${props.villageId}`;
  }
  axios.get(url).then((response) => {
    data.isLoading = false;
    data.markers = response.data.markers;
    data.mapCentre = response.data.mapCentre;
  });
});
</script>
